import React from 'react';
import { useLanguage } from '../../../features/language/useLanguage';

interface RoastTimePhasesSectionProps {
  showTargetLabels: boolean;
  dryingTime: string;
  dryingRatio: string;
  maillardTime: string;
  maillardRatio: string;
  developmentTime: string;
  developmentRatio: string;
}

export const RoastTimePhasesSection: React.FC<RoastTimePhasesSectionProps> = ({
  showTargetLabels,
  dryingTime,
  dryingRatio,
  maillardTime,
  maillardRatio,
  developmentTime,
  developmentRatio,
}) => {
  const { t } = useLanguage();
  return (
    <div className="bg-white border rounded-lg p-4 space-y-4">
      <h4 className="text-sm font-medium text-gray-700">
        {showTargetLabels ? t('roast.timePhases.targetTimePhases') : t('roast.timePhases.timePhases')}
      </h4>

      <div className="space-y-3">
        <div className="bg-yellow-300 rounded-md p-3">
          <div className="flex justify-between items-center text-md">
            <div>
              <span className="text-black text-md font-semibold">{t('roast.timePhases.dryingPhase')}</span>
              <div className="text-xs text-gray-700">{t('roast.timePhases.startToYellow')}</div>
            </div>
            <div className="flex items-center justify-center h-full">
              <span className="font-mono bg-gray-50 px-2 py-0.5 rounded flex justify-center font-bold">
                {dryingTime} | {dryingRatio}%
              </span>
            </div>
          </div>
        </div>

        <div className="bg-amber-500 rounded-md p-3">
          <div className="flex justify-between items-center text-md">
            <div>
              <span className="text-black text-md font-semibold">{t('roast.timePhases.maillardPhase')}</span>
              <div className="text-xs text-gray-700">{t('roast.timePhases.yellowToFirstCrack')}</div>
            </div>
            <div className="flex items-center justify-center h-full">
              <span className="font-mono bg-gray-50 px-2 py-0.5 rounded flex justify-center font-bold">
                {maillardTime} | {maillardRatio}%
              </span>
            </div>
          </div>
        </div>

        <div className="bg-amber-700 rounded-md p-3">
          <div className="flex justify-between items-center text-md">
            <div>
              <span className="text-black text-md font-semibold">{t('roast.timePhases.developmentPhase')}</span>
              <div className="text-xs text-gray-200">{t('roast.timePhases.firstCrackToEnd')}</div>
            </div>
            <div className="flex items-center justify-center h-full">
              <span className="font-mono bg-gray-50 px-2 py-0.5 rounded flex justify-center font-bold">
                {developmentTime} | {developmentRatio}%
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
